<mat-card>
  <mat-card-title>{{
    '+VENTILATION.REMOTE_CONTROLLER.UNASSIGN_VITOTROL_DEVICE_HEADER' | translate
  }}</mat-card-title>
  <mat-card-content>
    <div class="content__body">
      <app-banner>
        <p>{{ '+VENTILATION.REMOTE_CONTROLLER.UNASSIGN_VITOTROL_DEVICE_CONTENT' | translate }}</p>
      </app-banner>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button
      mat-stroked-button
      gtm="onCancel"
      gtmAction="cancel"
      gtmCategory="unAssignVitotrolModal"
      color="primary"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.NO' | translate }}
    </button>
    <button
      mat-raised-button
      gtm="onConfirm"
      gtmAction="onConfirm"
      gtmCategory="unAssignVitotrolModal"
      color="primary"
      (click)="onConfirm()"
    >
      {{ 'GENERAL.BUTTON.YES' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
